
module.service('FollowupService', service);


function service($http, $q, $timeout, ApiUrl, moment, momentConvertFilter,
                 ModelService) {
    var verificationUrl = ApiUrl.partial('verification'),
        educationPlacementUrl = ApiUrl.partial('education_placement');


    function getVerification(params) {
        return $http.get(verificationUrl(), {params: params})
            .then(unwrapResponse)
            .then(momentConvertFilter);
    }


    function getEducationPlacement(id) {
        return $http.get(educationPlacementUrl(id))
            .then(unwrapItem)
            .then(momentConvertFilter);
    }

    function getLastDate(placement, verifications) {
        var dates = verifications.items.map(function(v) { return v.date; });
        dates.push(placement.last_verified);
        return moment.max(dates);
    }

    function calculateDueDate(lastDate) {
        dueDate = moment(lastDate); // Copy the date
        dueDate.startOf('quarter').add(2, "quarters");
        return dueDate;
    }

    function calculateWindowEnd(endDate) {
        if (!moment.isMoment(endDate)) {
            return null;
        }
        endDate = moment(endDate);
        endDate.startOf('quarter').add(4, 'quarters');
        return endDate;
    }

    this.loadFollowup = function(type, id) {
        return ModelService.getRelation(type, id, 'verification')
            .then(function(data) {
                data.due_date = calculateDueDate(data.last_verification);
                data.window_end = calculateWindowEnd(data.enrollment_end);
                data.window_passed = data.window_end.isBefore(data.last_verification);
                return data;
            });
    };

    this.createPlacementFollowup = function(participant_id, placement,
                                            successful, date) {
        var data = {participant_id: participant_id,
                    successful: !!successful,
                    date: date}
        data[placement.$model_name + "_id"] = placement.id;
        return ModelService.post('verification', data);
    }
}

function unwrapVerificationCreate(response) {
    return {
        verification: response.data.item,
        deleted: (response.data.$deleted || [])
            .filter(function(i) { return i[0] === 'verification'; })
            .map(function(i) {return i[1]; }),
    }
}


function unwrapResponse(response) {
    return response.data;
}

function unwrapItem(response) {
    return response.data.item;
}